/**
 * PATH: packages/email-hub/src/feature/components/email-context-menu/allocationHelpers.ts
 * FILE_ID: EMAILHUB-CONTEXTMENU-ALLOCATION-HELPERS-001
 * PURPOSE: Pure email-allocation selectors used by the context menu.
 * WHY: Keeps the provider frame free of allocation-domain branching.
 */
import type { AllocateAiSuggestion } from '@quotech/kanban-host'

import type { Email } from '../../hooks/useEmails'

export function deriveAiSuggestion(
  email: Pick<Email, 'allocation_summary'>,
): AllocateAiSuggestion | null {
  const summary = email.allocation_summary
  if (!summary) return null
  if (summary.source !== 'AI_SUGGESTED_PENDING') return null
  if (summary.confidence == null) return null
  return {
    boardId: summary.board_id,
    laneId: summary.lane_id,
    confidence: summary.confidence,
  }
}

export function derivePriorAllocationId(
  email: Pick<Email, 'allocation_summary'>,
): string | null {
  const summary = email.allocation_summary
  if (!summary) return null
  if (
    summary.source !== 'AI_AUTO' &&
    summary.source !== 'AI_SUGGESTED_PENDING' &&
    summary.source !== 'AI_SUGGESTED_USER_CONFIRMED'
  ) {
    return null
  }
  return summary.allocation_id
}
